import "./i18n";
import { PROFILE_VIEW as BASE_PROFILE_VIEW } from "./config/routes";
export const PROFILE_VIEW = {
    ...BASE_PROFILE_VIEW,
};
